const DISCOVERY_PREFIX = 'mplayer-discovery';

const UP_NEXT = 'up-next';
const SKIPPABLE_CONTENT = 'skippable-content';
const NEXT_VIDEO = 'next-video';
const SMALL_NEXT_VIDEO = 'small-next-video';

const CLOSE = 'close';
const PLAY = 'play';
const TITLE = 'title';
const THUMBNAIL = 'thumbnail';
const DURATION = 'duration';
const COUNTDOWN_LOADER = 'countdown-loader';
const STAY_BUTTON = 'stay-button';
const PLAY_NEXT_BUTTON = 'play-next-button';
const KEEP_WATCHING_BUTTON = 'keep-watching-button';

export const getUpNextId = (playerId: string): string => `${DISCOVERY_PREFIX}-${UP_NEXT}-${playerId}`;

export const getCloseId = (playerId: string): string => `${DISCOVERY_PREFIX}-${UP_NEXT}-${CLOSE}-${playerId}`;

export const getPlayId = (playerId: string): string => `${DISCOVERY_PREFIX}-${NEXT_VIDEO}-${PLAY}-${playerId}`;

export const getTitleId = (playerId: string): string => `${DISCOVERY_PREFIX}-${NEXT_VIDEO}-${TITLE}-${playerId}`;

export const getThumbnailId = (playerId: string): string => `${DISCOVERY_PREFIX}-${NEXT_VIDEO}-${THUMBNAIL}-${playerId}`;

export const getSmallNextVideoId = (playerId: string): string => `${DISCOVERY_PREFIX}-${SMALL_NEXT_VIDEO}-${playerId}`;

export const getDurationId = (playerId: string): string => `${DISCOVERY_PREFIX}-${NEXT_VIDEO}-${DURATION}-${playerId}`;

export const getCountdownLoaderId = (playerId: string): string => `${DISCOVERY_PREFIX}-${NEXT_VIDEO}-${COUNTDOWN_LOADER}-${playerId}`;

export const getSkippableContentId = (playerId: string): string => `${DISCOVERY_PREFIX}-${SKIPPABLE_CONTENT}-${playerId}`;

export const getStayButtonId = (playerId: string): string => `${DISCOVERY_PREFIX}-${SKIPPABLE_CONTENT}-${STAY_BUTTON}-${playerId}`;

export const getPlayNextButtonId = (playerId: string): string => `${DISCOVERY_PREFIX}-${SKIPPABLE_CONTENT}-${PLAY_NEXT_BUTTON}-${playerId}`;

export const getKeepWatchingButtonId = (playerId: string): string => `${DISCOVERY_PREFIX}-${SKIPPABLE_CONTENT}-${KEEP_WATCHING_BUTTON}-${playerId}`;
